export default "/images/plane_old.svg?08e057c2b627d23cfd4f3cc750dafa2e";